// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3q8PE","header":"ClearentDisclaimer_header__4odog","inner":"ClearentDisclaimer_inner__1Ti6P"};